import { useCallback, useState } from "react";

/** Small self-contained toast for admin pages. */
export function useAdminToast() {
  const [message, setMessage] = useState("");

  const notify = useCallback((next: string) => {
    setMessage(next);
    window.setTimeout(() => setMessage(""), 3200);
  }, []);

  const node = message ? (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[120] max-w-[90vw]">
      <div className="flex items-center gap-3 bg-foreground-950 text-background-50 text-sm px-4 py-3 rounded-lg">
        <i className="ri-checkbox-circle-line text-accent-400 text-lg"></i>
        <span>{message}</span>
      </div>
    </div>
  ) : null;

  return { notify, node };
}